module.exports = __webpack_public_path__ + "static/VS_Assistant_icon-f127be39ffeafcaac8204d72a1e6f6f9.jpg";